import { render } from "./VerifyEmailIndex.vue?vue&type=template&id=53baddf2"
import script from "./VerifyEmailIndex.vue?vue&type=script&lang=js"
export * from "./VerifyEmailIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__